module.exports = __webpack_public_path__ + "img/block7.webp";